import {
    Typography,
} from "@mui/material";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import React, { useEffect } from 'react';
import FooterBangla from '../../../components/componentsBangla/FooterBangla';
import HeaderOthersBangla from '../../../components/componentsBangla/HeaderOthersBangla';
import upay_banner from './../../../assets/images/offer-banner-Add-Money-aro-easy-Upay-to-deshi-Landing.png';


const useStyle = makeStyles((theme) => ({
    root: {
        margin: "60px 0px",
        [theme.breakpoints.down("sm")]: {
            margin: "0px",
        },
    },
    title: {
        fontWeight: "500 !important",
        marginBottom: "20px !important",
        marginTop: "24px !important",
    },
    subTitle: {
        fontWeight: "500 !important",
        marginBottom: "20px !important",
        marginTop: "0px !important",
    },

    img: {
        maxWidth: "100%",
    },
    footer: {
        marginTop: "-80px",
    },
    card: {
        padding: "24px",
        boxShadow: "1px 1px 35px 1px #eee",
        borderRadius: "10px",
        marginTop: "32px",
        [theme.breakpoints.down("sm")]: {
            padding: "7px",
        },
    },
}));

const UpayBangla = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    const classes = useStyle();
    return (
        <>
            <HeaderOthersBangla title="ST Pay add money from Upay" category="Offers" />
            <div className={classes.root}>
                <Container maxWidth="lg">
                    <Grid container spacing={2}>
                        <Grid item md={12} style={{ width: "100%" }}>
                            <Box className={classes.card}>
                                <img src={upay_banner} alt="ST Pay add money from Upay" className={classes.img} />
                                <Typography variant="h3" className={classes.title}>
                                    ST Pay add money from Upay
                                </Typography>
                                <p>
                                Keeping in mind of your convenience, we have come up with add money feature from Upay.
                                </p>
                                <p>
                                Now you can instantly add money to your ST Pay wallet from Upay with <strong>free of charge.</strong>
                                </p>
                            </Box>
                            <Box className={classes.card}>
                                <Typography variant="h4" className={classes.subTitle}>
                                    Process Details
                                </Typography>

                                <p>Login to ST Pay >> Select “Add Money” >> Select “MFS to ST Pay” >> Select “Upay”</p>
                                <p>Enter amount >> Select “Next” </p>
                                <p>Now you will be redirected to Upay interface</p>
                                <p>Enter your ST Pay wallet number >> Select “Proceed” </p>
                                <p>An OTP will be shared to your number >> Enter OTP and verify >> Enter PIN and select “Proceed” </p>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </div>
            <div className={classes.footer}>
                <FooterBangla />
            </div>
        </>
    );
};

export default UpayBangla;